module.exports = __webpack_public_path__ + "static/media/control_camera_off.128626cb.svg";